var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconResidencyPermitSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9932 4.99805H3.99924C2.89509 4.99805 2 5.89314 2 6.99729V16.9935C2 18.0976 2.89509 18.9927 3.99924 18.9927H19.9932C21.0973 18.9927 21.9924 18.0976 21.9924 16.9935V6.99729C21.9924 5.89314 21.0973 4.99805 19.9932 4.99805Z",
    stroke: "#171C60",
    strokeWidth: 1.99924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.99609H21.9924",
    stroke: "#171C60",
    strokeWidth: 1.99924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResidencyPermitSmall);
export default __webpack_public_path__ + "static/media/icon_residency_permit_small.b6a96096f680b85ffeaa265f8babf18a.svg";
export { ForwardRef as ReactComponent };